import { Message } from '../../type';
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import { addDays, format } from 'date-fns';
import { useUser } from '../../hooks/store/useUser';
import { useIntl } from 'react-intl';
import { useLocale, useOpenUrl, nameInitials } from '@xolv-mybrightlink/common';

export const RawFileGalleryItem = (props: { message: Message }) => {
  const { fileName, messageType, authorGuid, createdDate, url } = props.message;
  const author = useUser(authorGuid);
  const avatar = author ? nameInitials(author) : '';
  const iconSrc =
    messageType === 'WORD'
      ? '/public/assets/icons/ic_word.svg'
      : '/public/assets/icons/ic_pdf.svg';
  const intl = useIntl();
  const locale = useLocale();
  const expireDate = format(
    addDays(createdDate.toDate(), 240),
    'MMMM dd, yyyy',
    { locale },
  );
  const openFile = useOpenUrl(url);
  return (
    <ListItem
      onClick={openFile}
      sx={{
        borderRadius: 3,
        border: 'solid 0.5px #d8dade',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        py: 2,
        px: 4,
        bgcolor: 'white',
        cursor: 'pointer',
      }}
    >
      <ListItemAvatar sx={{ minWidth: 'unset' }}>
        <Box
          component='img'
          src={iconSrc}
          sx={{ height: 40, objectFit: 'cover' }}
        />
      </ListItemAvatar>
      <ListItemText
        sx={{ pl: 4 }}
        primary={
          <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {fileName}
          </Typography>
        }
        secondaryTypographyProps={{ component: 'div', pt: 1 }}
        secondary={
          <ListItem component='div' sx={{ p: 0 }}>
            <ListItemAvatar sx={{ minWidth: 'unset', pr: 2 }}>
              <Avatar
                sx={{
                  width: 18,
                  height: 18,
                  bgcolor: '#626a7a',
                  fontSize: 10,
                  fontWeight: 600,
                }}
              >
                {avatar}
              </Avatar>
            </ListItemAvatar>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: 12,
              }}
            >
              {intl.formatMessage(
                { id: 'care-team.media.expire-on' },
                { date: expireDate },
              )}
            </Typography>
          </ListItem>
        }
      />
    </ListItem>
  );
};
